export default [
    // 出入库管理——销售发货
    {
        path: "SaleConsignment",
        name: "SaleConsignment",
        meta: {
            title: "销售发货"
        },
        component: () =>
            import("@/views/Home/InAndOut/outBound/SaleConsignment")
    },
    {
        path: "SaleConsignmentDetail",
        name: "SaleConsignmentDetail",
        meta: {
            title: "销售发货详情"
        },
        component: () =>
            import("@/views/Home/InAndOut/outBound/SaleConsignment/SaleConsignmentDetail")
    },
    {
        path: "PNSaleConsignmentDetail",
        name: "PNSaleConsignmentDetail",
        meta: {
            title: "销售发货详情"
        },
        component: () =>
            import("@/views/Home/InAndOut/outBound/SaleConsignment/PNSaleConsignmentDetail")
    },
    // 出入库管理——出库明细
    {
        path: "WarehouseOutDetail",
        name: "WarehouseOutDetail",
        meta: {
            title: "出库明细"
        },
        component: () =>
            import("@/views/Home/InAndOut/outBound/WarehouseOutDetail")
    },
    // 出入库管理——京东调库单
    {
        path: "JdStockTransferOrder",
        name: "JdStockTransferOrder",
        meta: {
            title: "京东调库单"
        },
        component: () =>
            import("@/views/Home/InAndOut/outBound/JdStockTransferOrder")
    },
    {
        path: "JdStockTransferOrderDetail",
        name: "JdStockTransferOrderDetail",
        meta: {
            title: "京东调库单详情"
        },
        component: () =>
            import("@/views/Home/InAndOut/outBound/JdStockTransferOrder/JdStockTransferOrderDetail")
    },
    {
        path: "WarehouseDetail",
        name: "WarehouseDetail",
        meta: {
            title: "调拨单详情"
        },
        component: () =>
            import("@/views/Home/InAndOut/outBound/JdStockTransferOrder/WarehouseDetail")
    },
    // 出入库管理——生产入库
    {
        path: "ProducWarehouse",
        name: "ProducWarehouse",
        meta: {
            title: "生产入库"
        },
        component: () =>
            import("@/views/Home/InAndOut/inBound/ProducWarehouse")
    },
    // 出入库管理——入库明细
    {
        path: "WarehouseInDetail",
        name: "WarehouseInDetail",
        meta: {
            title: "入库明细"
        },
        component: () =>
            import("@/views/Home/InAndOut/inBound/WarehouseInDetail")
    },
    // 出入库管理——入库预分配
    {
        path: "Preallocation",
        name: "Preallocation",
        meta: {
            title: "入库预分配"
        },
        component: () =>
            import("@/views/Home/InAndOut/inBound/Preallocation")
    },
    // 出入库管理——入库预分配详情
    {
        path: "PreallocationDetail",
        name: "PreallocationDetail",
        meta: {
            title: "入库预分配详情"
        },
        component: () =>
            import("@/views/Home/InAndOut/inBound/Preallocation/PreallocationDetail")
    },
     // 出入库管理——预测分配页面
     {
        path: "Distribution",
        name: "Distribution",
        meta: {
            title: "分配预测"
        },
        component: () =>
            import("@/views/Home/InAndOut/inBound/Preallocation/Distribution")
    },
]